// src/api/org/service.js
import { json } from "utils/http/client";

export const OrgAPI = {
  //get a organization
  getOrganization: (organizationId) =>
    json(`/org/get-a-organization/${organizationId}/`, { method: "GET" }),

  // organizations created by the current user (owner)
  listCreatedByUser: () =>
    json("/org/list-users-created-organizations/", { method: "GET" }),

  // organizations the current user belongs to
  listForUser: () => json("/org/list-user-organization/", { method: "GET" }),

  // get organization transactions
  getTransactions: (organizationId) =>
    json(`/org/organization/${organizationId}/transactions/`, {
      method: "GET",
    }),

  //update with method
  updateOrganization: (organizationId, data, method) =>
    json(`/org/update-organization/${organizationId}/`, {
      method: method,
      body: data,
    }),
};

export const UserAPI = {
  // get current user details
  getUserDetails: () => json("/auth/user-details-of-user/", { method: "GET" }),
};

export const SitesAPI = {
  // get sites for an organization
  listByOrganization: (organizationId) =>
    json(`/sites/organizations/${organizationId}/sites/`, { method: "GET" }),

  // get specific site data
  getById: (siteId) => json(`/sites/get-a-sites/${siteId}/`, { method: "GET" }),
};

export const SubscriptionAPI = {
  // check user subscription for an organization
  checkUserSubscription: (organizationId) =>
    json("/subscription/get-user-subscription/", {
      method: "POST",
      body: { organization_id: organizationId },
    }),
};

export const SnagObjectsAPI = {
  // get snag objects for a site
  getObjectById: (objectId) =>
    json(`/core/api/snag/${objectId}/`, { method: "GET" }),

  // upload snag object
  upload: (data) =>
    json(`/core/uploadsnagobjects/`, {
      method: "POST",
      body: data,
    }),
};
